// This component is a simple wrapper to apply basic css
// patterns to freeform content without needing to throw
// classes around everywhere.
import React from 'react';
import PropTypes from 'prop-types';
import { SemanticElement } from 'common/helpers';

import './content.less';

// Component name is to avoid clashes with semantic which
// has .content elements in modals, etc.
class HtmlContentInner extends SemanticElement {
  static className = 'html-content';
  render() {
    const { forwardedRef, children } = this.props;
    return (
      <div ref={forwardedRef} {...this.getProps()}>
        {children}
      </div>
    );
  }
}

HtmlContentInner.propTypes = {
  small: PropTypes.bool,
  tight: PropTypes.bool,
};

HtmlContentInner.defaultProps = {
  small: false,
  tight: false,
};

const HtmlContent = React.forwardRef((props, ref) => {
  return <HtmlContentInner {...props} forwardedRef={ref} />;
});

export default HtmlContent;
